import { add, format } from 'date-fns';
import moment from 'moment';
import React from 'react';

import Tooltip from '@mui/material/Tooltip';

export const formatDate = (date) => {
  return (date && moment(date).format('DD.MM.YYYY')) || '';
};

export const formatDateWithTooltip = (date) => {
  const tooltipTitle = formatDateWithTimestamp(date);
  const dateFormat = moment(date).format('DD.MM.YYYY.');
  return (
    <Tooltip title={tooltipTitle} placement="top" arrow={true}>
      <div>{dateFormat}</div>
    </Tooltip>
  );
};

export const formatDateWithTimestamp = (date) => {
  return moment(date).format('DD.MM.YYYY. HH:mm:ss');
};

export const formatCurrentDateWithTimestampForFileName = () => {
  const date = new Date();
  const result = `${date.getUTCDate()}-${
    date.getUTCMonth() + 1
  }-${date.getUTCFullYear()}_${date.getHours()}-${date.getMinutes()}-${date.getMilliseconds()}`;
  return result;
};

export const prepareDateForBE = (date) => {
  return moment(date).format();
};

export const prepareLocalDateForBE = (date) => {
  return (date && moment(date).format('DD.MM.YYYY')) || null;
};

export const formatDateToStartOfTheDay = (date) => {
  const formatedDate = moment(date).toDate();
  formatedDate.setHours(0);
  formatedDate.setMinutes(0);
  formatedDate.setSeconds(0);
  formatedDate.setMilliseconds(0);
  return prepareDateForBE(formatedDate);
};

export const minDateTo = (date) => {
  if (date) {
    const minDate = date;
    minDate.setDate(minDate.getDate() + 1);
    return minDate;
  } else {
    return '';
  }
};

export const reformatDate = (formatedDate) => {
  if (formatedDate) {
    const day = formatedDate?.split('.')[0];
    const month = formatedDate?.split('.')[1];
    const year = formatedDate?.split('.')[2];
    return new Date(year, month - 1, day);
  }
  return null;
};

//Ova metoda je za datum u formatu dd.MM.yyyy HH:mm:ss
export const reformatDateWithTimeStamp = (dateFromBE) => {
  if (dateFromBE) {
    const dateFormatArray = dateFromBE?.split('.');
    const day = dateFormatArray[0];
    const month = dateFormatArray[1];
    const year = dateFormatArray[2]?.substring(0, 4);
    const timeStampArray = dateFormatArray[2]?.substring(4)?.split(':');
    const hours = timeStampArray?.[0];
    const minutes = timeStampArray?.[1];
    const seconds = timeStampArray?.[2];
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }
  return null;
};

export const addTimes = (time1, time2, outputFormat = 'HH:mm:ss') => {
  const [hours1, minutes1, seconds1] = time1.split(':').map(Number);
  const [hours2, minutes2, seconds2] = time2.split(':').map(Number);
  const result = add(new Date(0, 0, 0, hours1, minutes1, seconds1), {
    hours: hours2,
    minutes: minutes2,
    seconds: seconds2,
  });
  return format(result, outputFormat);
};
